// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"78036a52","336":"b09d9571","453":"4ae34bdf","647":"a7d87cb8","888":"b2e19f3f"}[chunkId] + ".chunk.js";
};